/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EmailQuoteRequestState {
  Sent = "sent",
  PriceTooHigh = "price_too_high",
  Converted = "converted",
  Potential = "potential",
  Replied = "replied",
  NoService = "no_service",
}

export function instanceOfEmailQuoteRequestState(value: any): boolean {
  for (const key in EmailQuoteRequestState) {
    if (Object.prototype.hasOwnProperty.call(EmailQuoteRequestState, key)) {
      if (
        EmailQuoteRequestState[key as keyof typeof EmailQuoteRequestState] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EmailQuoteRequestStateFromJSON(
  json: any,
): EmailQuoteRequestState {
  return EmailQuoteRequestStateFromJSONTyped(json, false);
}

export function EmailQuoteRequestStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EmailQuoteRequestState {
  return json as EmailQuoteRequestState;
}

export function EmailQuoteRequestStateToJSON(
  value?: EmailQuoteRequestState | null,
): any {
  return value as any;
}

export function EmailQuoteRequestStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EmailQuoteRequestState {
  return value as EmailQuoteRequestState;
}
